import { render, staticRenderFns } from "./MidwifeSignupFormWidget.vue?vue&type=template&id=d9031b8c&"
import script from "./MidwifeSignupFormWidget.vue?vue&type=script&lang=ts&"
export * from "./MidwifeSignupFormWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports